// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"279":"component---src-pages-index-jsx","415":"component---src-pages-404-jsx"}[chunkId] || chunkId) + "-" + {"279":"50e5e8e1f5a178a2c8dc","415":"468942e56f2f706f020c","454":"89439b2064e62ab52b13"}[chunkId] + ".js";
};